import { render, staticRenderFns } from "./MediaGroupMediaList.vue?vue&type=template&id=70158875&"
import script from "./MediaGroupMediaList.vue?vue&type=script&lang=js&"
export * from "./MediaGroupMediaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports